@if (openSurveys.length > 0 && hasChanges) {
    <div class="mt-3 alert alert-warning">
        <span>Disabling {{ surveyTypeLabel }} feature for your {{ team ? "team" : "organisation" }} will result in the following surveys and
            all their corresponding submitted responses to be <b>deleted</b> upon 'Save'</span>
        @for (survey of openSurveys; track survey) {
            <div class="mt-3 mb-4">
                <adapt-display-survey [canEdit]="false"
                                      [forceLightBackground]="true"
                                      [survey]="survey"> </adapt-display-survey>
            </div>
        }
        <span>Click 'Cancel' if this is not what you want to do.</span>
    </div>
}
